module.exports = __webpack_public_path__ + "static/media/bowl-food-health-svgrepo-com.479f4a92.svg";